// extracted by mini-css-extract-plugin
export var headerCell = "_5f-1";
export var loadingSpinnerContainer = "_5f-4";
export var loadingStateCell = "_5f-5";
export var rowWrapper = "_5f-3";
export var standaloneTable = "_5f-6";
export var table = "_5f-0";
export var white = "_5f-2";